import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { exportarPosiblesClientes, filtrarLeads2, listarLeads } from '../../../actions/leadsActions';
import useSelectEstadosLeads from "../../../hooks/useSelectEstadosLeads";
import useSelectProyecto from '../../../hooks/useSelectProyectos';
import DatePicker from "react-datepicker";
import * as moment from 'moment';
import { avisoCorrecto, avisoError } from '../../components/AvisosMensajes/MensajesSwalf';
import useSelectFuenteMulti from '../../../hooks/useSelectFuenteMulti';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFire } from "@fortawesome/free-solid-svg-icons";

const style = {
  boton: {
    background: "#28314A",
    color: "#fff"
  },
  buttonText: {
    fontSize: "13px",
    background: "#28314A",
    color: '#fff'
  },
  textArchivo: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#aaa"
  }
}

const FormularioFiltroAsesor = ({ contacto = false, soloCalientes, setSoloCalientes, calientesCount = 0 }) => {
  const dispatch = useDispatch();
  const { usuario } = useSelector(state => state.usuario);
  const { leads, filtrado } = useSelector(state => state.leads);

  const [estado, SelectEstado, setEstado] = useSelectEstadosLeads(null);
  const [proyecto, SelectProyecto, setProyecto] = useSelectProyecto(null);
  const [fechaDesde, setFechaDesde] = useState(null);
  const [fechaHasta, setFechaHasta] = useState(null);
  const [fechaLlamada, setFechaLlamada] = useState(null);
  const [fuente, SelectFuente, setFuente] = useSelectFuenteMulti(null);
  const [checkOmitir, setCheckOmitir] = useState(false);
  const [filtrosLoaded, setFiltrosLoaded] = useState(false);
  const isInitialized = useRef(false);

  useEffect(() => {
    const savedEstado = localStorage.getItem('estado');
    const savedProyecto = localStorage.getItem('proyecto');
    const savedFechaDesde = localStorage.getItem('fechaDesde');
    const savedFechaHasta = localStorage.getItem('fechaHasta');
    const savedFechaLlamada = localStorage.getItem('fechaLlamada');
    const savedFuente = localStorage.getItem('fuente');
    const savedCheckOmitir = localStorage.getItem('checkOmitir');

    if (savedEstado) setEstado(JSON.parse(savedEstado));
    if (savedProyecto) setProyecto(JSON.parse(savedProyecto));
    if (savedFechaDesde) setFechaDesde(new Date(savedFechaDesde));
    if (savedFechaHasta) setFechaHasta(new Date(savedFechaHasta));
    if (savedFechaLlamada) setFechaLlamada(new Date(savedFechaLlamada));
    if (savedFuente) setFuente(JSON.parse(savedFuente));
    if (savedCheckOmitir) setCheckOmitir(JSON.parse(savedCheckOmitir));
    setFiltrosLoaded(true);
  }, []);

  // Carga inicial al montar
  useEffect(() => {
    if (filtrosLoaded) {
      traerDatos();
      isInitialized.current = true;
    }
  }, [filtrosLoaded]);

  // Búsqueda dinámica: se dispara al cambiar cualquier filtro (debounce 600ms)
  useEffect(() => {
    if (!isInitialized.current) return;
    const timer = setTimeout(traerDatos, 600);
    return () => clearTimeout(timer);
  }, [estado, proyecto, fechaDesde, fechaHasta, fechaLlamada, fuente, checkOmitir]);

  useEffect(() => {
    localStorage.setItem('estado', JSON.stringify(estado));
    localStorage.setItem('proyecto', JSON.stringify(proyecto));
    if (fechaDesde) localStorage.setItem('fechaDesde', fechaDesde.toISOString());
    if (fechaHasta) localStorage.setItem('fechaHasta', fechaHasta.toISOString());
    if (fechaLlamada) localStorage.setItem('fechaLlamada', fechaLlamada.toISOString());
    localStorage.setItem('fuente', JSON.stringify(fuente));
    localStorage.setItem('checkOmitir', JSON.stringify(checkOmitir));
  }, [estado, proyecto, fechaDesde, fechaHasta, fechaLlamada, fuente, checkOmitir]);

  const handleExportar = async () => {
    const respuesta = await exportarPosiblesClientes(leads, usuario.id_usuario);
    if (respuesta.exito) {
      avisoCorrecto(respuesta.message);
    } else {
      avisoError(respuesta.message);
    }
  };

  const traerDatos = () => {
    if ((fechaDesde && fechaHasta) && fechaLlamada) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No puedes aplicar filtros por Fecha de Registro y Fecha de Llamada al mismo tiempo.',
      });
      return;
    }

    if (!estado && !proyecto && (!fechaDesde || fechaDesde === '') && !fechaHasta && !fechaLlamada && (!fuente || fuente === '') && !checkOmitir) {
      dispatch(listarLeads(usuario, contacto));
    } else {
      const datosFiltro = {
        estado: estado,
        fechaDesde: fechaDesde ? moment(fechaDesde).format('YYYY-MM-DD') : null,
        fechaHasta: fechaHasta ? moment(fechaHasta).format('YYYY-MM-DD') : null,
        fechaLlamada: fechaLlamada ? moment(fechaLlamada).format('YYYY-MM-DD') : null,
        proyecto: proyecto ? proyecto : null,
        fuente: fuente !== '' ? fuente : null,
        checkOmitir: checkOmitir
      };
      dispatch(filtrarLeads2(datosFiltro, usuario, contacto));
    }
  };

  const limpiarFiltros = () => {
    setEstado(null);
    setProyecto(null);
    setFechaDesde(null);
    setFechaHasta(null);
    setFechaLlamada(null);
    setFuente(null);
    setCheckOmitir(false);
    localStorage.removeItem('estado');
    localStorage.removeItem('proyecto');
    localStorage.removeItem('fechaDesde');
    localStorage.removeItem('fechaHasta');
    localStorage.removeItem('fechaLlamada');
    localStorage.removeItem('fuente');
    localStorage.removeItem('checkOmitir');
    dispatch(listarLeads(usuario, contacto));
  };

  return (
    <div className="card mb-2" style={{ border: '1px solid #dee2e6' }}>
      <div className="card-body p-2">
        <div className="row align-items-end mx-n1">
          <div className="col-md-2 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Estado</label>
            <SelectEstado />
          </div>
          <div className="col-md-3 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Producto</label>
            <SelectProyecto />
          </div>
          <div className="col-md-2 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Fuente</label>
            <SelectFuente />
          </div>
          <div className="col-md-2 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Desde (Registro)</label>
            <DatePicker
              selected={fechaDesde}
              onChange={(date) => setFechaDesde(date)}
              selectsStart
              dateFormat="dd/MM/yyyy"
              autoComplete="off"
              name="fechaDesde"
              className="form-control form-control-sm"
            />
          </div>
          <div className="col-md-2 px-1 mb-2">
            <label className="small font-weight-bold mb-1">Hasta (Registro)</label>
            <DatePicker
              selected={fechaHasta}
              onChange={(date) => setFechaHasta(date)}
              selectsStart
              dateFormat="dd/MM/yyyy"
              autoComplete="off"
              name="fechaHasta"
              className="form-control form-control-sm"
            />
          </div>
          <div className="col-md-1 px-1 mb-2">
            <label className="small font-weight-bold mb-1">F. Llamada</label>
            <DatePicker
              selected={fechaLlamada}
              onChange={(date) => setFechaLlamada(date)}
              selectsStart
              dateFormat="dd/MM/yyyy"
              autoComplete="off"
              name="fechaLlamada"
              className="form-control form-control-sm"
            />
          </div>
        </div>
        <div className="d-flex align-items-center" style={{ gap: '8px' }}>
          <button className="btn btn-sm btn-outline-secondary" onClick={limpiarFiltros}>
            <i className="fas fa-times mr-1"></i>Limpiar filtros
          </button>
          {setSoloCalientes && (
            <button
              className="btn btn-sm"
              onClick={() => setSoloCalientes(!soloCalientes)}
              style={{
                backgroundColor: soloCalientes ? '#fd7e14' : '#fff',
                color: soloCalientes ? '#fff' : '#fd7e14',
                border: '1px solid #fd7e14',
                fontWeight: 600,
                boxShadow: soloCalientes ? '0 0 8px #fd7e1480' : 'none',
                transition: 'all .15s ease-in-out',
              }}
              title={soloCalientes ? 'Mostrando solo leads calientes — clic para ver todos' : 'Filtrar solo leads calientes'}
            >
              <FontAwesomeIcon icon={faFire} className="mr-1" />
              Calientes ({calientesCount})
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormularioFiltroAsesor;
